import React, { useContext, useState } from "react";
import { userContext } from "../context/UserContext";
import { api_url } from "../helpers";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  const { user, setLoad } = useContext(userContext);
  const navigate = useNavigate();
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [Subject, setSubject] = useState("");
  const [Message, setMessage] = useState("");

  // prevent page reload
  async function ContactUs(e) {
    e.preventDefault();

    setLoad(true);

    //form data
    const ContactUsData = new FormData();

    ContactUsData.append("full_name", Name);
    ContactUsData.append("email", Email);
    ContactUsData.append("phone", Phone);
    ContactUsData.append("subject", Subject);
    ContactUsData.append("message", Message);

    const response = await fetch(
      api_url + "method/erp_sn.api.contact_us.submit_contact_us",
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
        method: "POST",
        body: ContactUsData,
      }
    );

    if (response.ok == true) {
      const data = await response.json();

      // console.log(data);

      if (data?.message?.lead_name) {
        toast.success("Your form has been filled");

        setTimeout(() => {
          navigate("/");
        }, 500);
      } else {
        toast.error("Form already exist");
      }
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  return (
    <section className="contact py-30">
      <div className="container container-lg ">
        <div className="container ">
          <div className="row  mb-60 d-flex justify-content-between">
            <div className="col-lg-6 order-lg-1 order-2 py-60 aboutus-text">
              <h4 className="m-0">Contact Us</h4>
              <p>
                Let’s Connect
                <br />
                At SupplyNest, we value strong partnerships and clear
                communication. Whether you have an inquiry, need a custom supply
                solution, or want to discuss a potential collaboration, our team
                is here to help. You can reach us through any of the following
                channels:
              </p>
              <div className="row d-flex justify-content-between">
                <div className="col-lg-7">
                  <p>
                    <b className="text-dark">
                      Address:
                      <br />
                      <a href="#" className="info-custom">
                        Shop No.7, AL Zenia Complex 2
                      <br/>
                        Ground Floor, Near McDonald's
                        <br/>
                        Ibn Khaldoun Street
                        <br/>
                         Hawally, Kuwait
                      </a>
                    </b>
                  </p>
                </div>
                <div className="col-lg-5">
                  <p className="pb-lg-0">
                    <b className="text-dark">
                      Phone:
                      <br />
                      <a href="#" className="info-custom">
                        +965 1234578
                      </a>
                    </b>
                  </p>
                  <p>
                    <b className="text-dark">
                      Email:
                      <br />
                      <a href="#" className="info-custom  ">info@supplynest.com</a>
                    </b>
                  </p>
                </div>
              </div>
              <p>
                Our team is available during business hours to assist you
                promptly and professionally. We look forward to supporting your
                business needs.
              </p>
              <p>
                Let us know how we can help — we're just a call or message away.
              </p>
            </div>
            <div className="col-lg-5 order-lg-2 order-1 d-flex align-items-center justify-content-center">
              <img
                src="assets\images\icon\istockphoto-903568822-612x612.jpg"
                alt=""
                className="rounded-8"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <div className="container">
          <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
            <form action="#" onSubmit={(e) => ContactUs(e)}>
              <h6 className="mb-32">Make Custom Request</h6>
              <div className="row gy-4">
                <div className="col-sm-6 col-xs-6">
                  <label
                    htmlFor="name"
                    className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                  >
                    Full Name{" "}
                    <span className="text-danger text-xl line-height-1">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input px-16"
                    id="name"
                    placeholder="Full name"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-6 col-xs-6">
                  <label
                    htmlFor="email"
                    className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                  >
                    Email Address{" "}
                    <span className="text-danger text-xl line-height-1">*</span>{" "}
                  </label>
                  <input
                    type="email"
                    className="common-input px-16"
                    id="email"
                    placeholder="Email address"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-6 col-xs-6">
                  <label
                    htmlFor="phone"
                    className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                  >
                    Phone Number
                    <span className="text-danger text-xl line-height-1">
                      *
                    </span>{" "}
                  </label>
                  <input
                    type="number"
                    className="common-input px-16"
                    id="phone"
                    placeholder="Phone Number*"
                    value={Phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-6 col-xs-6">
                  <label
                    htmlFor="subject"
                    className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                  >
                    Subject
                    <span className="text-danger text-xl line-height-1">
                      *
                    </span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input px-16"
                    id="subject"
                    placeholder="Subject"
                    value={Subject}
                    onChange={(e) => setSubject(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-12">
                  <label
                    htmlFor="message"
                    className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                  >
                    Message
                    <span className="text-danger text-xl line-height-1">
                      *
                    </span>{" "}
                  </label>
                  <textarea
                    className="common-input px-16"
                    id="message"
                    placeholder="Type your message"
                    defaultValue={""}
                    value={Message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-12 mt-32">
                  <button
                    type="submit"
                    className="btn btn-main py-18 px-32 rounded-8"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
